import axios from 'axios';
import * as myConstClass from '../Config/config.js';
import { Encrypt } from '../Helpers/Common'; //Include Home

const END_POINT = myConstClass.BACKEND_ENDPOINT;
const AUTH_TOKEN = myConstClass.AUTH_TOKEN;

const headers = {
  "Access-Control-Allow-Origin": "*",
  'Access-Control-Allow-Credentials': true,
  'x-access-auth-token': '' + AUTH_TOKEN + '',
}

export async function SubscriptionPlans() {

  return axios.post(END_POINT + '/subscription/plans', '', {
    headers: headers
  }).then(response => {
    return response;
  });

}

export async function EthiopiaPlans() {
  return axios.post(END_POINT + '/subscription/ethiopiaplans', '', {
    headers: headers

  }).then(response => {
    return response;
  });
}

export async function EthiopiaSubscription(msisdn, product_id) {
  var body = {
    msisdn: "251" + msisdn,
    product_id: product_id
  }
  return axios.post(END_POINT + '/subscription/ethiopiasubscription', body, {
    headers: headers
  }).then(response => {
    return response;
  });
}

export async function EthiopiaCancelSubscription(msisdn, product_id) {
  var body = {
    msisdn: msisdn,
    product_id: product_id
  }
  return axios.post(END_POINT + '/subscription/ethiopiacancelsubscription', body, {
    headers: headers
  }).then(response => {
    return response;
  });
}

export async function CreateOrder(Postdata) {

  return await Encrypt(Postdata).then(res => {
    const postData = {
      "digest": res
    }
    return axios.post(END_POINT + '/subscription/createorder', postData, {
      headers: headers
    }).then(res => {
      //const data = res;
      return res;
    });
  })

}


export async function Creategrace(Postdata) {

  return await Encrypt(Postdata).then(res => {
    const postData = {
      "digest": res
    }
    return axios.post(END_POINT + '/subscription/create-grace', postData, {
      headers: headers
    }).then(res => {
      //const data = res;
      return res;
    });
  })

}

export async function RzrpayCreateOrder(Postdata) {

  return await axios.post(END_POINT + '/subscription/rzrpaycreateorder', Postdata, {
    headers: headers
  }).then(res => {

    return res.data;
  });
}

export async function ccavenueprocessorder(Postdata) {

  return await Encrypt(Postdata).then(res => {
    const postData = {
      "digest": res
    }
    return END_POINT + '/subscription/process-ccavenue-order?digest=' + res;
    /* return axios.post(END_POINT+'/subscription/process-ccavenue-order',postData,{
       headers: headers
     }).then(res => {
           //const data = res;
           return res;
         });*/
  })

}




